<template>
  <div class="tickBox">
    <el-row>
      <el-col :span="24" class="tickMid">
        <el-col :span="12" class="mma"> 订单管理 </el-col>
        <el-col :span="12" class="rigrig">
          <el-button type="primary" plain class="butsTwo" @click="handleExcel"
            >全部导出</el-button
          >

          <el-upload
            class="upload-demo"
            :action="importOrder()"
            :limit="10"
            accept=".xlsx"
            :on-success="handsuccess"
            :show-file-list="false"
          >
            <el-button type="primary" plain class="butsTwo"
              >批量导入运单</el-button
            >
          </el-upload>

          <el-upload
            class="upload-demo"
            :action="importFreight()"
            :limit="10"
            accept=".xlsx"
            :on-success="handsuccess"
            :show-file-list="false"
          >
            <el-button type="primary" plain class="butsTwo">导入运费</el-button>
          </el-upload>
          <!-- <el-button type="primary" class="butsTwo" @click="handleSearch">勾选导出</el-button> -->
        </el-col>
      </el-col>
    </el-row>
    <el-row style="background: #fff">
      <el-col :span="24" class="formBox"></el-col>
      <div style="display: inline-block">
        <span class="spanfont"> 订单编号 </span>
        <div class="radioBox">
          <el-input v-model="codeValue" placeholder="请输入订单编号"></el-input>
        </div>
      </div>
      <div style="display: inline-block">
        <span class="spanfont"> 账号 </span>
        <div class="radioBox">
          <el-input
            v-model="payaccount"
            placeholder="请输入开设账号检索"
          ></el-input>
        </div>
      </div>
      <div>
        <div style="display: inline-block">
          <span class="spanfont"> 下单日期 </span>

          <div class="radioBox">
            <el-date-picker
              format="yyyy-MM-dd"
              v-model="date"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div style="display: inline-block; margin-left: 45px">
          <el-radio-group
            v-model="radio3"
            size="small"
            @change="handleRadioChange"
          >
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button label="100">待收货</el-radio-button>
            <el-radio-button label="200">已完成</el-radio-button>
            <el-radio-button label="300">已取消</el-radio-button>
          </el-radio-group>
        </div>
        <div style="display: inline-block">
          <div class="radioBox">
            <el-button type="primary" plain class="butsOne" @click="handleReset"
              >重置</el-button
            >
            <el-button type="primary" class="butsTwo" @click="handleSearch"
              >查询</el-button
            >
          </div>
        </div>
      </div>
    </el-row>
    <el-row>
      <el-col :span="24" v-loading="loading" class="tabBox">
        <el-table
          ref="multipleTable"
          :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange"
          @select-all="handelSelectAll"
          :data="tableData"
          border
          style="width: 100%"
          row-key="id"
        >
          <el-table-column type="selection" reserve-selection width="55">
          </el-table-column>
          <el-table-column prop="xh" label="序号" width="55px">
          </el-table-column>
          <el-table-column prop="" label="账号" width="115px">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.phone"
                placement="top"
              >
                <span>{{ scope.row.phone }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="" label="用户名" width="150px">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.name"
                placement="top"
              >
                <span>{{ scope.row.name }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="orderId" label="订单编号" width="120px">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.orderId"
                placement="top"
              >
                <span>{{ scope.row.orderId }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="changeid" label="转单号" width="150px">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.changeid"
                placement="top"
              >
                <span>{{ scope.row.changeid }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="sendcmpname" label="发件人公司" width="150px">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.sendcmpname"
                placement="top"
              >
                <span>{{ scope.row.sendcmpname }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="sendname" label="发件人姓名" width="100px">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.sendname"
                placement="top"
              >
                <span>{{ scope.row.sendname }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="receiptcountry"
            label="目的地国家"
            width="100px"
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.receiptcountry"
                placement="top"
              >
                <span>{{ scope.row.receiptcountry }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="packageweight" label="重量" width="60px">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.packageweight"
                placement="top"
              >
                <span>{{ scope.row.packageweight }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="appointmentdate"
            label="区间日期"
            width="100px"
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.appointmentdate"
                placement="top"
              >
                <span>{{ scope.row.appointmentdate }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="appointmenttime" label="时间段">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.appointmenttime"
                placement="top"
              >
                <span>{{ scope.row.appointmenttime }}</span>
              </el-tooltip>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="stringCreateTime"
            label="下单时间"
            width="100px"
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.stringCreateTime"
                placement="top"
              >
                <span>{{ scope.row.stringCreateTime }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="appointmentremark"
            label="其他要求"
            width="100px"
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.appointmentremark"
                placement="top"
              >
                <span>{{ scope.row.appointmentremark }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="订单状态" width="120px">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 100">待收货</div>
              <div v-if="scope.row.status == 200">已完成</div>
              <div v-if="scope.row.status == 300">已取消</div>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作" width="100px">
            <template slot-scope="scope">
              <div>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      @click.native="handleRowClick(scope.row.orderId)"
                      >查看详情</el-dropdown-item
                    >
                    <el-dropdown-item
                      @click.native="handleRowExport(scope.row.orderId)"
                      >导出发票</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="scope.row.status === '100'"
                      @click.native="cancellation(scope.row.orderId)"
                      >订单已取消</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="scope.row.status === '100'"
                      @click.native="finish(scope.row.orderId)"
                      >订单已完成</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="scope.row.status != '300'"
                      @click.native="alter(scope.row)"
                      >修改转单号</el-dropdown-item
                    >
                    <el-dropdown-item
                      @click.native="modifyMoney(scope.row)"
                      >修改金额</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="scope.row.status === '100'"
                      @click.native="alterOrder(scope.row)"
                      >修改订单</el-dropdown-item
                    >
                    <el-dropdown-item
                      type="text"
                      @click.native="changeRecord(scope.row)"
                      >修改记录</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-clipboard:copy="
                        scope.row.orderId +
                          '\n' +
                          scope.row.statustype +
                          '\n' +
                          scope.row.name +
                          '\n' +
                          scope.row.sendcmpname +
                          '\n' +
                          scope.row.sendaddress +
                          '\n' +
                          scope.row.sendtel +
                          '\n' +
                          scope.row.sendname +
                          '\n' +
                          scope.row.receiptcountry +
                          '\n' +
                          scope.row.packageweight +
                          '\n' +
                          scope.row.appointmentdate +
                          '\n' +
                          scope.row.appointmentremark
                      "
                      v-clipboard:success="clipboardSuccessHandler"
                      v-clipboard:error="clipboardErrorHandler"
                      >复制订单信息</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="通知">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.native="inform(scope.row)"
                v-clipboard:copy="
                  scope.row.orderId +
                    '\n' +
                    scope.row.statustype +
                    '\n' +
                    scope.row.name +
                    '\n' +
                    scope.row.sendcmpname +
                    '\n' +
                    scope.row.sendaddress +
                    '\n' +
                    scope.row.sendtel +
                    '\n' +
                    scope.row.sendname +
                    '\n' +
                    scope.row.receiptcountry +
                    '\n' +
                    scope.row.packageweight +
                    '\n' +
                    scope.row.appointmentdate +
                    '\n' +
                    scope.row.appointmentremark
                "
                v-clipboard:success="informSuccessHandler"
                v-clipboard:error="informErrorHandler"
              >
                通知取件
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="basicmoney" label="基础运费" width="120px">
            <template slot-scope="scope">{{ scope.row.basicmoney }}</template>
          </el-table-column>
          <el-table-column prop="othermoney" label="其他杂费" width="120px">
            <template slot-scope="scope">{{ scope.row.othermoney }}</template>
          </el-table-column>
          <el-table-column prop="totalmoney" label="合计" width="120px">
            <template slot-scope="scope">{{ scope.row.totalmoney }}</template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" class="pageBox">
        <div class="pagination">
          <!-- 分页 -->
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="nowpage"
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :page-size="pagelist"
            :total="this.totalPage"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="内容修改"
      :visible.sync="shows"
      width="400px"
      :close-on-click-modal="false"
    >
      <div>
        <div class="demo-input-suffix">
          订单编号:
          <el-input placeholder="请输入内容" :disabled="true" v-model="names">
          </el-input>
        </div>
        <div class="demo-input-suffix">
          转单号：
          <el-input placeholder="请输入内容" v-model="vals"> </el-input>
        </div>
        <div class="gogo">
          <el-button class="trueChange" @click="changeClick" type="primary"
            >确认修改</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="订单修改"
      :visible.sync="showOrder"
      width="800px"
      :close-on-click-modal="false"
      id="alterOrder"
    >
      <div
        style="display: flex; flex-wrap: wrap; justify-content: space-around"
      >
        <!-- <div class="demo-input-suffix">
          订单编号:
          <el-input placeholder="请输入内容" v-model="orderId"> </el-input>
        </div> -->
        <div class="demo-input-suffix">
          付款方：
          <el-radio-group
            v-model="paytype"
            style="
              border-radius: 4px;
              border: 1px solid #dcdfe6;
              padding: 10px 13px;
            "
          >
            <el-radio style="margin-right: 0" :label="1">发件人</el-radio>
            <el-radio style="margin-right: 0" :label="2">收件人</el-radio>
            <el-radio style="margin-right: 0" :label="3">第三方</el-radio>
          </el-radio-group>
        </div>
        <div class="demo-input-suffix">
          付款人账号：
          <el-input placeholder="请输入内容" v-model="payaccount"> </el-input>
        </div>
        <div class="demo-input-suffix">
          付款账号国家：
          <el-input placeholder="请输入内容" v-model="paycountry"> </el-input>
        </div>
        <div class="demo-input-suffix">
          付款账号所属公司：
          <el-input placeholder="请输入内容" v-model="paycmpname"> </el-input>
        </div>
        <div class="demo-input-suffix">
          发件人姓名：
          <el-input placeholder="请输入内容" v-model="sendname"> </el-input>
        </div>
        <div class="demo-input-suffix">
          发件人电话：
          <el-input placeholder="请输入内容" v-model="sendtel"> </el-input>
        </div>
        <div class="demo-input-suffix">
          发件人公司：
          <el-input placeholder="请输入内容" v-model="sendcmpname"> </el-input>
        </div>
        <div class="demo-input-suffix">
          发件人地址：
          <el-input placeholder="请输入内容" v-model="sendaddress"> </el-input>
        </div>
        <div class="demo-input-suffix">
          发件人城市：
          <el-input placeholder="请输入内容" v-model="sendcity"> </el-input>
        </div>
        <div class="demo-input-suffix">
          发件人邮编：
          <el-input placeholder="请输入内容" v-model="sendpostcode"> </el-input>
        </div>
        <div class="demo-input-suffix">
          发件人国家：
          <el-input placeholder="请输入内容" v-model="sendcountry"> </el-input>
        </div>
        <div class="demo-input-suffix">
          发件人邮箱：
          <el-input placeholder="请输入内容" v-model="sendemail"> </el-input>
        </div>
        <div class="demo-input-suffix">
          收件人姓名：
          <el-input placeholder="请输入内容" v-model="receiptname"> </el-input>
        </div>
        <div class="demo-input-suffix">
          收件人号码：
          <el-input placeholder="请输入内容" v-model="receipttel"> </el-input>
        </div>
        <div class="demo-input-suffix">
          收件人公司：
          <el-input placeholder="请输入内容" v-model="receiptcmpname">
          </el-input>
        </div>
        <div class="demo-input-suffix">
          收件人地址：
          <el-input placeholder="请输入内容" v-model="receiptaddress">
          </el-input>
        </div>
        <div class="demo-input-suffix">
          收件人城市：
          <el-input placeholder="请输入内容" v-model="receiptcity"> </el-input>
        </div>
        <div class="demo-input-suffix">
          收件人邮编：
          <el-input placeholder="请输入内容" v-model="receiptpostcode">
          </el-input>
        </div>
        <div class="demo-input-suffix">
          收件人国家/地区：
          <el-input placeholder="请输入内容" v-model="receiptcountry">
          </el-input>
        </div>
        <div class="demo-input-suffix">
          收件人税号：
          <el-input placeholder="请输入内容" v-model="receipttaxno"> </el-input>
        </div>
        <div class="demo-input-suffix">
          收件人邮箱：
          <el-input placeholder="请输入内容" v-model="receiptemail"> </el-input>
        </div>
        <div class="demo-input-suffix">
          网络渠道：
          {{ channeltype }}
          <el-select v-model="channeltype" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <!-- <el-input placeholder="请输入内容" v-model="channeltype"> </el-input> -->
        </div>
        <div class="demo-input-suffix">
          包裹箱数：
          <el-input placeholder="请输入内容" v-model="packagenum"> </el-input>
        </div>
        <div class="demo-input-suffix">
          包裹重量：
          <el-input placeholder="请输入内容" v-model="packageweight">
          </el-input>
        </div>
        <div class="demo-input-suffix">
          包裹尺寸：
          <el-input placeholder="请输入内容" v-model="packagesize"> </el-input>
        </div>
        <div class="demo-input-suffix">
          包裹内物品：
          <el-input placeholder="请输入内容" v-model="packagegoods"> </el-input>
        </div>
        <div class="demo-input-suffix">
          其他物品：
          <el-input placeholder="请输入内容" v-model="othergoods"> </el-input>
        </div>
        <div class="demo-input-suffix">
          重量：
          <el-input placeholder="请输入内容" v-model="weight"> </el-input>
        </div>
        <div class="demo-input-suffix">
          体积：
          <el-input placeholder="请输入内容" v-model="volume"> </el-input>
        </div>
        <div class="demo-input-suffix">
          预约时间段：
          <!-- <el-time-select
            v-model="appointmenttime"
            :picker-options="{
              start: '08:30',
              step: '00:30',
              end: '18:30',
            }"
            placeholder="选择时间"
          >
          </el-time-select> -->
          <el-input placeholder="请输入内容" v-model="appointmenttime">
          </el-input>
        </div>
        <div class="demo-input-suffix">
          预约日期：
          <el-date-picker
            v-model="appointmentdate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <!-- <el-input placeholder="请输入内容" v-model="appointmentdate">
          </el-input> -->
        </div>
        <!-- <div class="demo-input-suffix">
          下单时间：
          <el-input placeholder="请输入内容" v-model="stringCreateTime">
          </el-input>
        </div> -->
        <div class="demo-input-suffix">
          其他要求：
          <el-input placeholder="请输入内容" v-model="appointmentremark">
          </el-input>
        </div>
        <div class="demo-input-suffix">
          数量：
          <el-input placeholder="请输入内容" v-model="num"> </el-input>
        </div>
        <div class="demo-input-suffix">
          总价值：
          <el-input placeholder="请输入内容" v-model="totalvalue"> </el-input>
        </div>
        <div class="demo-input-suffix">
          HS编码：
          <el-input placeholder="请输入内容" v-model="hs"> </el-input>
        </div>
        <div class="demo-input-suffix">
          预留单号:
          <el-input placeholder="请输入内容" v-model="reservationnumber">
          </el-input>
        </div>
        <div class="gogo" style="width: 30%; margin-top: 24px">
          <el-button
            class="trueChange"
            @click="trueAlterOrder"
            type="primary"
            style="width: 100%"
            >确认修改</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 修改记录弹框 -->
    <el-dialog title="修改记录" :visible.sync="changeRecordDialog" width="60%">
      <el-table :data="changeRecordList" style="width: 100%">
        <el-table-column prop="name" label="修改人"> </el-table-column>
        <el-table-column prop="timeStr" label="修改时间" width="200px">
        </el-table-column>
        <el-table-column prop="content" label="修改字段" width="200px">
        </el-table-column>
        <el-table-column prop="oldvalue" label="修改旧值"> </el-table-column>
        <el-table-column prop="newvalue" label="修改新值" width="200px">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <!-- 修改金额弹框 -->
    <el-dialog title="修改金额" :visible.sync="modifyMoneyDialog" width="30%">
      <el-form
        ref="modifyMoneyListRef"
        :model="modifyMoneyList"
        label-width="80px"
      >
        <el-form-item label="基础运费">
          <el-input v-model="modifyMoneyList.basicmoney"></el-input>
        </el-form-item>
        <el-form-item label="其他杂费">
          <el-input v-model="modifyMoneyList.othermoney"></el-input>
        </el-form-item>
        <el-form-item label="合计">
          <el-input v-model="modifyMoneyList.totalmoney"></el-input>
        </el-form-item>
      </el-form>
      <span style="font-size:12px;color:##606266;"
        >此价格仅供参考，最终以账单为准</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyMoneyDialog = false">取 消</el-button>
        <el-button type="primary" @click="modifyMoneySubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import Vue from "vue";
import axios from "axios";
export default {
  data() {
    return {
      modifyMoneyList: {},
      modifyMoneyDialog: false,
      date: [],
      multipleSelection: [],
      SelectAll: [], //多选框,全选后的id数组
      totalB: "",
      totalA: "", //首次渲染total
      notice: "", // 通知取件
      nowpage: 1,
      pagelist: 10,
      loading: true,
      codeValue: "",
      payaccount: "",
      codeDate: "",
      phoneValue: "",
      timeValue: [],
      value1: [],
      input: "",
      tableData: [],
      value: "",
      total: 100,
      pageSize: "1",
      comValue: "",
      status: "",
      totalPage: 0,
      show: false,
      shows: false,
      showOrder: false,
      names: "",
      vals: "",
      radio3: "",
      orderId: "",
      paytype: "",
      payaccount: "",
      paycountry: "",
      paycmpname: "",
      sendname: "",
      sendtel: "",
      sendcmpname: "",
      sendaddress: "",
      sendcity: "",
      sendpostcode: "",
      sendcountry: "",
      sendemail: "",
      receiptname: "",
      receipttel: "",
      receiptcmpname: "",
      receiptaddress: "",
      receiptcity: "",
      receiptpostcode: "",
      receiptcountry: "",
      receipttaxno: "",
      receiptemail: "",
      channeltype: "",
      packagenum: "",
      packageweight: "",
      packagesize: "",
      packagegoods: "",
      othergoods: "",
      weight: "",
      volume: "",
      appointmentdate: "",
      appointmenttime: "",
      appointmentremark: "",
      appointmentdate: "",
      num: "",
      totalvalue: "",
      hs: "",
      reservationnumber: "",
      options: [
        {
          value: "1",
          label: "FedEx"
        },
        {
          value: "2",
          label: "DHL"
        },
        {
          value: "3",
          label: "TNT"
        },
        {
          value: "4",
          label: "UPS"
        },
        {
          value: "5",
          label: "专线"
        },
        {
          value: "6",
          label: "授权销售代表选择"
        },
        {
          value: "7",
          label: "IDE印尼专线"
        }
      ],
      tablist: [],
      orderidsList: [],
      changeRecordDialog: false,
      changeRecordList: []
    };
  },
  created() {
    this.newHandeOrder();
  },
  mounted() {
    this.handleAjax();
    this.language();
  },

  watch: {
    totalB: function(val, oldVal) {
      if (oldVal === "") {
        oldVal = val;
      }
      if (val !== oldVal) {
        var that = this;
        var audio = new Audio("/static/video/语音提示.mp3");
        audio.play();
        that.$notify({
          title: "新订单",
          message: "您有新的订单待处理"
        });
      }
    }
  },

  methods: {
    //修改金额
    modifyMoney(row) {
      console.log("row",row)
      this.modifyMoneyDialog = true;
      this.modifyMoneyList=row;
    },
    //修改金额提交
    modifyMoneySubmit() {
      var bizContent = {};
      bizContent.basicmoney = this.modifyMoneyList.basicmoney;
      bizContent.othermoney = this.modifyMoneyList.othermoney;
      bizContent.totalmoney = this.modifyMoneyList.totalmoney;
      bizContent.orderId = this.modifyMoneyList.orderId;
      this.ajax
        .post(this.versatile.withurl + "/order/changemoney", { bizContent })
        .then(res => {
          if ((res.data.status = "0000")) {
            this.$message.success("修改金额成功!");
            this.modifyMoneyDialog=false;
          }
          console.log(res);
        });
    },
    //查询订单总条数,用于监听新订单
    newHandeOrder() {
      let bizContent = {};
      bizContent.currentPage = "1";
      bizContent.pageSize = "10";
      this.ajax
        .post(this.versatile.withurl + "/order/orderList", { bizContent })
        .then(res => {
          console.log("查询total" + res.data.data.data.total);
          this.totalA = res.data.data.data.total;
          this.totalB = res.data.data.data.total;
        });
    },
    handelSelectAll(rows) {
      var a = [];
      rows.forEach(item => {
        a.push(item.id);
      });
      this.$refs.multipleTable.toggleRowSelection(a);
    },
    handleRowExport(id) {
      console.log(id);
      let bizContent = {};
      bizContent.orderId = id;
      axios({
        method: "post",
        url: this.versatile.withurl + "/order/downloadword",
        responseType: "blob",
        data: {
          bizContent
        }
      }).then(res => {
        let blob = new Blob([res.data], { type: "application/msword" }); // res就是接口返回的文件流了
        let objectUrl = URL.createObjectURL(blob);

        const link = document.createElement("a"); //我们用模拟q标签点击事件
        const fname = id; //下载文件的名字
        link.href = objectUrl;
        link.setAttribute("download", fname);
        document.body.appendChild(link);
        /**
         * 在这期间，我们可以做自己界面的反应逻辑
         **/
        link.click(); //点击
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(URL); // 释放掉blob对象
        // window.location.href = objectUrl;
      });
    },
    handleSelectionChange(val) {
      console.log("val", val);
      this.orderidsList = val;
      this.multipleSelection = val;
    },
    handleExcel() {
      let that = this;
      console.log(this);
      let orderids,
        order = [];
      if (this.orderidsList) {
        this.orderidsList.forEach(res => {
          order.push(res.orderId);
        });
        orderids = order.join(",");
      }
      let bizContent = {};
      bizContent.orderids = orderids;
      this.ajax
        .post(this.versatile.withurl + "/order/orderListExport", { bizContent })
        .then(res => {
          console.log(res.data.data);
          this.tablist = res.data.data;
          const title = ["11111", "", "", "", "", "", "", ""];
          require.ensure([], () => {
            const {
              export_json_to_excel
            } = require("../../vendor/Export2Excel");
            // 对应表格输出的title
            const tHeader = [
              // "序号",
              "用户名",
              "内单号",
              "渠道",
              "转单号",
              "包裹总件数",
              "包裹总件数",
              "包裹总重量",
              "体积",
              "目的地"
            ];
            // 对应表格输出的数据
            const filterVal = [
              // "id",
              "name",
              "orderId",
              "channeltypename",
              "changeid",
              "packagenum",
              "packageweight",
              "packagesize",
              "receiptcountry"
            ];
            // const list = this.tablist;
            console.log(that.tablist);
            const data = this.formatJson(filterVal, that.tablist);
            // 对应下载文件的名字
            export_json_to_excel(tHeader, data, "订单管理");
          });
        });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },

    handleCurrentChange(val) {
      this.nowpage = val;
      this.handleAjax();
    },
    //语音
    language() {
      let bizContent = {};
      bizContent.currentPage = "1";
      bizContent.pageSize = "10";
      setInterval(() => {
        this.ajax
          .post(this.versatile.withurl + "/order/orderList", { bizContent })
          .then(item => {
            if (this.totalB == item.data.data.data.total) {
              return console.log("没有新增订单");
            } else {
              this.totalB = item.data.data.data.total;
              return;
            }
          });
      }, 3000);
    },
    getTime(time) {
      var date = new Date(time);
      console.log(date);
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return y + "-" + m + "-" + d;
    },
    handleAjax() {
      // console.log(this.date);
      this.loading = true;
      let bizContent = {};
      bizContent.currentPage = this.nowpage;
      bizContent.pageSize = "10";
      bizContent.comValue = this.comValue;
      bizContent.codeValue = this.codeValue;
      bizContent.payaccount = this.payaccount;
      if (this.date != null) {
        if (this.date.length > 0) {
          bizContent.datebegin = this.getTime(this.date[0]);
          bizContent.dateend = this.getTime(this.date[1]);
        }
      }
      bizContent.uid = "";
      bizContent.status = this.radio3;
      this.ajax
        .post(this.versatile.withurl + "/order/orderList", { bizContent })
        .then(result => {
          console.log(result);
          if (result.data.status == "0000") {
            let arr = result.data.data.data.data;
            this.totalPage = result.data.data.data.total;
            console.log(result.data.data.data.data);
            result.data.data.data.data.forEach(item => {
              if (item.status === "100") {
                Vue.set(item, "statustype", "待收货");
              } else if (item.status === "200") {
                Vue.set(item, "statustype", "已完成");
              } else if (item.status === "300") {
                Vue.set(item, "statustype", "已取消");
              }
            });
            arr.map((it, index) => {
              it.xh = index + 1;
            });
            this.tableData = arr;
            this.total = result.data.data.total;
            this.loading = false;
          } else {
            this.$message(result.data.data.message);
          }
        });
    },
    handleChangePage(val) {
      this.pageSize = val;
      this.handleAjax();
    },
    handleClick(row) {
      this.$router.push({
        path: "/mentMonInfor",
        query: {
          id: row.Buid,
          code: row.Borganization_code
        }
      });
    },
    handleChangeTime() {},
    handleReset() {
      this.comValue = "";
      this.codeValue = "";
      this.radio3 = "";
      this.codeDate = "";
      this.payaccount = "";
      // this.phoneValue=''
      // this.timeValue=[]
      // this.value1=[]
    },
    handleSearch() {
      console.log(this.comValue, this.codeValue, this.radio3);
      this.status = this.radio3;
      this.handleAjax();
    },
    handleRowClick(val) {
      this.$router.push({
        name: "CustomInfo",
        query: {
          oId: val
        }
      });
    },
    showlist() {
      this.show = !this.show;
    },
    cancellation(val) {
      console.log(val);
      let bizContent = {};
      bizContent.orderId = val;
      bizContent.status = "300";
      this.ajax
        .post(this.versatile.withurl + "/order/changeorder", {
          bizContent
        })
        .then(() => {
          this.handleAjax();
        });
      this.show = !this.show;
    },
    finish(val) {
      console.log(val);

      let bizContent = {};
      bizContent.orderId = val;
      bizContent.status = "200";
      this.ajax
        .post(this.versatile.withurl + "/order/changeorder", {
          bizContent
        })
        .then(() => {
          this.handleAjax();
        });
      this.show = !this.show;
    },
    //复制信息
    copyText(text) {
      var textarea = document.createElement("input"); //创建input对象
      var currentFocus = document.activeElement; //当前获得焦点的元素
      document.body.appendChild(textarea); //添加元素
      textarea.value = text;
      textarea.focus();
      if (textarea.setSelectionRange)
        textarea.setSelectionRange(0, textarea.value.length);
      //获取光标起始位置到结束位置
      else textarea.select();
      try {
        var flag = document.execCommand("copy"); //执行复制
      } catch (eo) {
        var flag = false;
      }
      document.body.removeChild(textarea); //删除元素
      currentFocus.focus();
      return flag;
    },
    // 通知取件
    inform(row) {
      // var str =
      //   row.orderId +
      //   " \n " +
      //   row.statustype +
      //   " \n " +
      //   row.name +
      //   " \n " +
      //   row.sendcmpname +
      //   " \n " +
      //   row.sendaddress +
      //   " \n " +
      //   row.sendtel +
      //   " \n " +
      //   row.sendname +
      //   " \n " +
      //   row.receiptcountry +
      //   " \n " +
      //   row.packageweight +
      //   " \n " +
      //   row.appointmentdate +
      //   " \n " +
      //   row.appointmentremark;
      // //复制信息
      // console.log(str);
      // let flag = this.copyText(str);
      // if (flag) {
      //   this.$message.success("通知成功!");
      // } else {
      //   this.$message.error("通知失败!");
      // }

      let bizContent = {};
      bizContent.orderId = row.orderId;
      this.ajax
        .post(this.versatile.withurl + "/order/changenotice", {
          bizContent
        })
        .then(res => {
          console.log("res", res);
          this.handleAjax();
        });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.billurl === "1") {
        return "success-row";
      }
      return "";
    },
    alter(val) {
      console.log(val);
      this.names = val.orderId;
      this.vals = val.changeid;
      this.shows = !this.shows;
    },
    alterOrder(val) {
      console.log(val.paytype);
      this.orderId = val.orderId;
      this.paytype = val.paytype;
      this.payaccount = val.payaccount;
      this.paycountry = val.paycountry;
      this.paycmpname = val.paycmpname;
      this.sendname = val.sendname;
      this.sendtel = val.sendtel;
      this.sendcmpname = val.sendcmpname;
      this.sendaddress = val.sendaddress;
      this.sendcity = val.sendcity;
      this.sendpostcode = val.sendpostcode;
      this.sendcountry = val.sendcountry;
      this.sendemail = val.sendemail;
      this.receiptname = val.receiptname;
      this.receipttel = val.receipttel;
      this.receiptcmpname = val.receiptcmpname;
      this.receiptaddress = val.receiptaddress;
      this.receiptcity = val.receiptcity;
      this.receiptpostcode = val.receiptpostcode;
      this.receiptcountry = val.receiptcountry;
      this.receipttaxno = val.receipttaxno;
      this.receiptemail = val.receiptemail;
      if (val.channeltype == "1") {
        this.channeltype = "FedEx";
      } else if (val.channeltype == "2") {
        this.channeltype = "DHL";
      } else if (val.channeltype == "3") {
        this.channeltype = "TNT";
      } else if (val.channeltype == "4") {
        this.channeltype = "UPS";
      } else if (val.channeltype == "5") {
        this.channeltype = "专线";
      } else if (val.channeltype == "6") {
        this.channeltype = "授权销售代表选择";
      } else if (val.channeltype == "7") {
        this.channeltype = "IDE印尼专线";
      }

      this.packagenum = val.packagenum;
      this.packageweight = val.packageweight;
      this.packagesize = val.packagesize;
      this.packagegoods = val.packagegoods;
      this.othergoods = val.othergoods;
      this.weight = val.weight;
      this.volume = val.volume;
      this.appointmentdate = val.appointmentdate;
      this.appointmenttime = val.appointmenttime;
      this.appointmentremark = val.appointmentremark;
      this.appointmentdate = val.appointmentdate;
      this.showOrder = !this.showOrder;
      this.num = val.num;
      this.totalvalue = val.totalvalue;
      this.reservationnumber = val.reservationnumber;
      this.hs = val.hs;
    },
    trueAlterOrder() {
      let bizContent = {};
      bizContent.orderId = this.orderId;
      bizContent.paytype = this.paytype;
      bizContent.payaccount = this.payaccount;
      bizContent.paycountry = this.paycountry;
      bizContent.paycmpname = this.paycmpname;
      bizContent.sendname = this.sendname;
      bizContent.sendtel = this.sendtel;
      bizContent.sendcmpname = this.sendcmpname;
      bizContent.sendaddress = this.sendaddress;
      bizContent.sendcity = this.sendcity;
      bizContent.sendpostcode = this.sendpostcode;
      bizContent.sendcountry = this.sendcountry;
      bizContent.sendemail = this.sendemail;
      bizContent.receiptname = this.receiptname;
      bizContent.receipttel = this.receipttel;
      bizContent.receiptcmpname = this.receiptcmpname;
      bizContent.receiptaddress = this.receiptaddress;
      bizContent.receiptcity = this.receiptcity;
      bizContent.receiptpostcode = this.receiptpostcode;
      bizContent.receiptcountry = this.receiptcountry;
      bizContent.receipttaxno = this.receipttaxno;
      bizContent.receiptemail = this.receiptemail;
      bizContent.num = this.num;
      bizContent.totalvalue = this.totalvalue;
      bizContent.reservationnumber = this.reservationnumber;
      bizContent.hs = this.hs;
      if (this.channeltype === "FedEx") {
        bizContent.channeltype = "1";
      } else if (this.channeltype === "DHL") {
        bizContent.channeltype = "2";
      } else if (this.channeltype === "TNT") {
        bizContent.channeltype = "3";
      } else if (this.channeltype === "UPS") {
        bizContent.channeltype = "4";
      } else if (this.channeltype === "专线") {
        bizContent.channeltype = "5";
      } else if (this.channeltype === "授权销售代表选择") {
        bizContent.channeltype = "6";
      } else if (this.channeltype === "IDE印尼专线") {
        bizContent.channeltype = "7";
      } else {
        bizContent.channeltype = this.channeltype;
      }
      bizContent.packagenum = this.packagenum;
      bizContent.packageweight = this.packageweight;
      bizContent.packagesize = this.packagesize;
      bizContent.packagegoods = this.packagegoods;
      bizContent.othergoods = this.othergoods;
      bizContent.weight = this.weight;
      bizContent.volume = this.volume;
      bizContent.appointmentdate = this.appointmentdate;
      bizContent.appointmenttime = this.appointmenttime;
      bizContent.appointmentremark = this.appointmentremark;
      bizContent.appointmentdate = this.appointmentdate;
      bizContent.changer = "佳洪电子";
      this.ajax
        .post(this.versatile.withurl + "/order/changeorderdetail", {
          bizContent
        })
        .then(result => {
          console.log(this.channeltype);
          console.log(bizContent);
          if (result.data.status === "0000") {
            location.reload();
          }
        });
    },
    clipboardSuccessHandler({ value, event }) {
      this.$message({
        message: "复制成功",
        showClose: true,
        type: "success"
      });
      console.log("success", value, event);
    },

    clipboardErrorHandler({ value, event }) {
      this.$message({
        message: "复制失败",
        showClose: true,
        type: "error"
      });
      console.log("error", value);
    },
    informSuccessHandler({ value, event }) {
      this.$message({
        message: "通知成功",
        showClose: true,
        type: "success"
      });
      console.log("success", value, event);
    },

    informErrorHandler({ value, event }) {
      this.$message({
        message: "通知失败",
        showClose: true,
        type: "error"
      });
      console.log("error", value);
    },
    // copy(val) {
    //   console.log(val);
    //   let _this = this;
    //   var clipboard = new Clipboard("#copy", {
    //     text: function () {
    //       return val.orderId;
    //     },
    //   });
    //   console.log(clipboard);
    //   clipboard.on("success", (e) => {
    //     console.log(111);
    //     this.$message({
    //       message: "复制成功",
    //       showClose: true,
    //       type: "success",
    //     });
    //     // 释放内存
    //     clipboard.destroy();
    //   });
    //   clipboard.on("error", (e) => {
    //     this.$message({ message: "复制失败,", showClose: true, type: "error" });
    //     // 不支持复制
    //     // Message({
    //     //   message: "该浏览器不支持自动复制",
    //     //   type: "warning",
    //     // });
    //     // 释放内存
    //     clipboard.destroy();
    //   });
    // },
    changeClick() {
      this.ajax
        .post(this.versatile.withurl + "/order/changeno", {
          bizContent: { orderId: this.names, changeno: this.vals }
        })
        .then(result => {
          if (result.data.status == "0000") {
            swal({
              text: "修改成功！",
              timer: 3000,
              buttons: false
            });
            this.shows = false;
            this.handleAjax();
          } else {
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            });
          }
        });
    },
    handleRadioChange(val) {
      this.handleAjax();
    },
    showText(val) {
      console.log(val);
    },
    importOrder() {
      return "https://api.with-ex.net/order/importorder";
    },
    importFreight() {
      return "https://api.with-ex.net/order/importmoney";
    },
    handsuccess() {
      this.$message({
        message: "导入成功",
        showClose: true,
        type: "success"
      });
      this.handleAjax();
    },
    //修改记录
    changeRecord(row) {
      console.log("修改记录");
      console.log(row.orderId);
      this.changeRecordDialog = true;
      this.ajax
        .post(this.versatile.withurl + "/order/orderchangeList", {
          bizContent: { orderid: row.orderId }
        })
        .then(res => {
          this.changeRecordList = res.data.data;
          // console.log(res);
        });
    }
  }
};
</script>

<style scoped>
.other {
  position: absolute;
}
.tickBox {
  margin-left: 20px;
}
.tickMid {
  margin-top: 10px;
  width: 100%;
  background: #fff;
  height: 55px;
  line-height: 50px;
  text-align: left;
  padding: 10px 15px;
}
.mma {
  font-size: 24px;
  padding-left: 10px;
}
.rigrig {
  text-align: right;
}
.rigrig .upload-demo {
  display: inline-block;
}
.formBox {
  padding: 20px 5px 20px 15px;
  background: #fff;
  /* border: 2px solid #eee;
    box-shadow: 2px 2px 4px #eee; */
  /* margin: 10px 0; */
}
.alls {
  margin-top: 20px;
}
.radioBox {
  height: 40px;
  line-height: 40px;
  margin-right: 10px;
  display: inline-block;
  margin-bottom: 10px;
}
.radioBox >>> .el-input__inner {
  width: 224px;
}
.selBox {
  margin-right: 20px;
}

.butsOne {
  width: 74px;
  height: 30px;
  padding: 0;
}
.butsTwo {
  /* width: 74px; */
  height: 30px;
  padding: 0 15px;
  margin-right: 20px;
}
.spanfont {
  height: 40px;
  width: 70px;
  display: inline-block;
  text-align: right;
  line-height: 40px;
  margin-right: 5px;
  margin-left: 5px;
  color: #333333;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
}
.pickBox > .el-input__inner {
  width: 305px;
}
.tabBox {
  /* min-height: 720px; */
  background: #fff;
  padding: 0 20px;
}
/* .tabBox>>>.el-table__empty-text{
    min-height: 360px;
    line-height: 360px;
} */
.tabBox >>> .el-table__body-wrapper {
  min-height: 600px;
  overflow-y: auto;
}
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar {
  width: 15px;
  height: 15px;
}
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
.pageBox {
  text-align: center;
  margin: 20px 0;
}
#alterOrder .demo-input-suffix {
  width: 30%;
}
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar {
	    width: 5px; /*滚动条宽度*/
	    height: 15px; /*滚动条高度*/
	}
	/*定义滚动条轨道 内阴影+圆角*/
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar-track {
	    box-shadow: 0px 1px 3px white inset; /*滚动条的背景区域的内阴影*/
	    border-radius: 10px; /*滚动条的背景区域的圆角*/
	    background-color: white; /*滚动条的背景颜色*/
	}
	/*定义滑块 内阴影+圆角*/
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
	    box-shadow: 0px 1px 3px #409EFF inset; /*滚动条的内阴影*/
	    border-radius: 10px; /*滚动条的圆角*/
	    background-color: #409EFF; /*滚动条的背景颜色*/
	}
</style>



// WEBPACK FOOTER //
// src/PAGE/bankAcceptance/custom.vue